import accessibility from '../assets/accessibility.svg';

export default function AccessibilityModal({ info, venue }) {

    return (
        <div>
            <a href="/" data-bs-toggle="modal" data-bs-target="#accessibilityInfoModal">
                <img src={accessibility} alt='accessibility info icon'></img>
            </a> 

            <div className="modal fade" id="accessibilityInfoModal" tabIndex="-1" aria-labelledby="accessibilityInfoModal" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">{`Accessibility at ${venue}`}</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {info}
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
}